module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/dcar-score-cd1674c77c03f1c9feee12721e0930f5.png";